export default "__VITE_PUBLIC_ASSET__f88e29ee__"